// AUTO-GENERATED FILE. Do not edit.
import  { EvolutionTriggerName, PokeData } from "types/pokemon/poke-data";
import  { PokeType } from "types/pokemon/poke-type";

export const bramblin: PokeData = {
  "id": 946,
  "name": "bramblin",
  "height": 6,
  "weight": 6,
  "base_experience": 55,
  "types": [
    PokeType.GRASS,
    PokeType.GHOST
  ],
  "api_moves": [
    "disable",
    "absorb",
    "mega-drain",
    "defense-curl",
    "curse",
    "giga-drain",
    "rollout",
    "pain-split",
    "rapid-spin",
    "astonish",
    "bullet-seed",
    "power-whip",
    "hex",
    "phantom-force",
    "infestation"
  ],
  "moves": [
    "curse",
    "bullet-seed",
    "power-whip",
    "phantom-force",
    "confuse-ray",
    "energy-ball",
    "lick",
    "night-shade",
    "branch-poke",
    "soul-sacrifice",
    "frenzy-plant",
    "synthesis",
    "vine-whip"
  ],
  "evolution_chain": {
    "id": 495,
    "item": null,
    "species": [
      {
        "name": "bramblin",
        "order": 974,
        "types": [
          PokeType.GRASS,
          PokeType.GHOST
        ],
        "evolves_from_species_id": null,
        "pokemonevolutions": []
      },
      {
        "name": "brambleghast",
        "order": 975,
        "types": [
          PokeType.GRASS,
          PokeType.GHOST
        ],
        "evolves_from_species_id": 946,
        "pokemonevolutions": [
          {
            "type": null,
            "min_level": null,
            "item": null,
            "location": null,
            "min_happiness": null,
            "min_affection": null,
            "min_beauty": null,
            "move": null,
            "relative_physical_stats": null,
            "time_of_day": "",
            "trade_species_id": null,
            "turn_upside_down": false,
            "held_item_name": null,
            "evolutiontrigger": {
              "name": EvolutionTriggerName.OTHER
            },
            "gender": null
          }
        ]
      }
    ]
  },
  "stats": {
    "resistance": 36.25,
    "speed": 60,
    "ability_power": 65
  },
  "stat_changes": [],
  "catch_rate": 190,
  "is_legendary": false,
  "is_mythical": false,
  "is_mega": false,
  "is_gmax": false,
  "regional_variant": null
} as const;
